import React from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import Header from '../component/Header'
import Loading from '../component/Loading'
import Title from '../component/Title'
import Footer from '../component/Footer'
import { Link } from 'react-router-dom'

function ReferInfo({id, title, desc, image, category, property, element}){
    return (
        <li>
            <Link to = {{ 
                pathname: 'reference-detail',
                state: {id, title, desc, image, category, property, element}
            }}>
                <span className="alpha">{id}</span>
                <span className="tag">{title}</span>
                <span className="desc">{desc}</span>
            </Link>
        </li>
    )
}

ReferInfo.prototype = {
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
}

class Reference extends React.Component {
    state = {
        isLoading: true,
        refer: []
    };

    getRefer = async() => {
        const {
            data: {
                data: {refer},
            },
        } = await axios.get("https://giyoung1225.github.io/dothome/reference.json");
        console.log(refer);
        this.setState({ refer, isLoading: false})
    }

    componentDidMount(){
        setTimeout(() => {
            this.getRefer();
        }, 1000);
    }

    render(){
        const { isLoading, refer } = this.state;

        return (
            <div>
                <Header />
                { isLoading ? (
                    <div className="loading">
                        <Loading />
                    </div>
                ) : (
                    <main id="main">
                            <section id="referCont">
                                <div className="container">
                                    <div className="titleWrap">
                                        <Title text={['Reference','Book','Reference Book']} />
                                    </div>
                                    <div className="referCont">
                                        <h2>HTML</h2>
                                        <ul>
                                            { refer.map( (port, index) => (
                                                <ReferInfo
                                                    key={index}
                                                    id={port.id}
                                                    title={port.title}
                                                    desc={port.desc}
                                                    image={port.image}
                                                    category={port.category}
                                                    property={port.property}
                                                    element={port.element}
                                                />
                                            )) }
                                        </ul>
                                        
                                    </div>
                                </div>
                            </section>
                    </main>
                )}
                <Footer />
            </div>
        )
    }
}

export default Reference